import React, { useState, useEffect } from "react";
import { MenuLateral } from "../../../../Components/MenuLateral/Index";
import { Panel } from "../../../../Components/Panel";
import { Header } from "../../../../Components/Header";
import { PerfilInput } from "../../../../Components/PerfilInput";
import { useCartorio } from "../../../../Hooks/cartorio";
import { Alert } from "../../../../Components/Error/Alert";
import {
  Container,
  Formulario,
  HelperInput,
  HandleButton,
  HandleOperationButtons,
  HandleEditarButton,
} from "./styles";
import { DarkButton } from "../../../../Components/DarkButton";
import { validateEmail } from "../../../../Services/validaEmail";
import { validateCPF } from "../../../../Services/validateCPF";
import { limpa_cpf_cnpj } from "../../../../Services/limpa_cpf_cnpj";
import { validateCNPJ } from "../../../../Services/validateCPNJ";
import { limpaMaskCelular } from "../../../../Services/limpaMaskCelular";
import { validaCelular } from "../../../../Services/validaCelular";
import api from "../../../../Services/api";
import { ModalLoader } from "../../../../Components/ModalLoader";
import { useFuncionarioCartorio } from "../../../../Hooks/funcionarioCartorio";
import { EditarSenhaModal } from "../../../../Components/EditarSenhaModal";
import { usePrefeitura } from "../../../../Hooks/usePrefeitura";
import { useFuncionarioPrefeitura } from "../../../../Hooks/funcionarioPrefeitura";

export function Funcionario_Perfil() {
  const {
    funcionarioCartorio,
    handleSetFuncionarioCartorio,
  } = useFuncionarioCartorio();

  const {
    FuncionarioPrefeitura,
    handleSetFuncionarioPrefeitura
  } = useFuncionarioPrefeitura();


  const { cartorio } = useCartorio();
  const { prefeitura } = usePrefeitura();
  const [NOME, setNome] = useState("");

  const [EMAIL, setEMAIL] = useState("");
  const [WHATS, setWHATS] = useState("");
  const [FONE, setFONE] = useState("");
  const [SENHA, setSENHA] = useState("");
  const [loading, setloading] = useState(false);
  const [editarSenhaModal, setEditarSenhaModal] = useState(false);
  const [error, setError] = useState({ message: "", title: "" } as {
    message: string;
    title: string;
  });

  useEffect(() => {
    restoreValues();
  }, [funcionarioCartorio,FuncionarioPrefeitura]);

  function handleSetNome(nNome: string) {
    setNome(nNome);
  }
  function handlesetEMAIL(str: string) {
    setEMAIL(str);
  }
  function handlesetWHATS(str: string) {
    setWHATS(str);
  }
  function handlesetFONE(str: string) {
    setFONE(str);
  }

  function validaForm() {
    if (!validateEmail(EMAIL)) {
      setError({
        message: `O endereço de email digitado não é válido!`,
        title: "Email Inválido!",
      });
      return false;
    }

    if (Number(limpaMaskCelular(WHATS)) > 0) {
      if (!validaCelular(limpaMaskCelular(WHATS))) {
        setError({
          message: `O número de celular não é válido!`,
          title: "Celular Inválido!",
        });
        return false;
      }
    }

    if (Number(limpaMaskCelular(FONE)) > 0) {
      if (!validaCelular(limpaMaskCelular(FONE))) {
        setError({
          message: `O número de telefone não é válido!`,
          title: "Telefone Inválido!",
        });
        return false;
      }
    }

    return true;
  }

  async function post() {
    try {
      //await  checarToken();
      setloading(true);
      if(funcionarioCartorio.ID){
        const { data } = await api.put(`/funcionario-cartorio/update`, {
          NOME,
          EMAIL,
          WHATS: limpaMaskCelular(WHATS),
          FONE: limpaMaskCelular(FONE),
          SENHA: SENHA ? SENHA : funcionarioCartorio.SENHA,
          CPF: funcionarioCartorio.CPF,
          ID: funcionarioCartorio.ID,
          ATIVO: funcionarioCartorio.ATIVO,
          CARTORIO_ID: funcionarioCartorio.CARTORIO_ID,
        });
  
        handleSetFuncionarioCartorio(data);
      }else{
        const { data } = await api.put(`/funcionario-PREFEITURA/update`, {
          NOME,
          EMAIL,
          WHATS: limpaMaskCelular(WHATS),
          FONE: limpaMaskCelular(FONE),
          SENHA: SENHA ? SENHA : FuncionarioPrefeitura.SENHA,
          CPF: FuncionarioPrefeitura.CPF,
          ID: FuncionarioPrefeitura.ID,
          ATIVO: FuncionarioPrefeitura.ATIVO,
          PREFEITURA_ID: FuncionarioPrefeitura.PREFEITURA_ID,
        });
  
        handleSetFuncionarioPrefeitura(data);
      }
    
      setFormStatus("Visualizar");
    } catch (error) {
      setError({
        title: "Erro ao tentar atualizar conta!",
        message:
          "Não foi possível atualizar seus dados! Tente novamente mais tarde!",
      });
    } finally {
      setloading(false);
    }
  }

  function restoreValues() {
    if(FuncionarioPrefeitura.ID){
      setNome(FuncionarioPrefeitura.NOME);

      setEMAIL(
        FuncionarioPrefeitura.EMAIL
          ? FuncionarioPrefeitura.EMAIL
          : "exemplo@email.com"
      );
      setWHATS(
        FuncionarioPrefeitura.WHATS ? FuncionarioPrefeitura.WHATS : "00000000000"
      );
      setFONE(FuncionarioPrefeitura.FONE ? FuncionarioPrefeitura.FONE : "0000000000");

    }else{
      setNome(funcionarioCartorio.NOME);

      setEMAIL(
        funcionarioCartorio.EMAIL
          ? funcionarioCartorio.EMAIL
          : "exemplo@email.com"
      );
      setWHATS(
        funcionarioCartorio.WHATS ? funcionarioCartorio.WHATS : "00000000000"
      );
      setFONE(funcionarioCartorio.FONE ? funcionarioCartorio.FONE : "0000000000");
    }
   
  }

  const [formStatus, setFormStatus] = useState(
    "Visualizar" as "Visualizar" | "Editar"
  );

  return (
    <Container>
      <MenuLateral titulo={funcionarioCartorio.ID? cartorio.NOME:prefeitura.NOME} />
      <Panel
        children={
          <>
            <Header type={"PERFIL"} />

            <Formulario>
              <HelperInput>
                <PerfilInput
                  execute={handleSetNome}
                  value={NOME}
                  title={"NOME"}
                  ativo={false}
                  disabled={formStatus == "Visualizar"}
                />
                <PerfilInput
                  execute={handlesetEMAIL}
                  value={EMAIL}
                  title={"EMAIL"}
                  ativo={false}
                  disabled={formStatus == "Visualizar"}
                />
              </HelperInput>

              <HelperInput>
                <PerfilInput
                  execute={handlesetFONE}
                  value={FONE}
                  title={"FONE"}
                  ativo={false}
                  disabled={formStatus == "Visualizar"}
                />
                <PerfilInput
                  execute={handlesetWHATS}
                  value={WHATS}
                  title={"CELULAR"}
                  ativo={false}
                  disabled={formStatus == "Visualizar"}
                />
              </HelperInput>
            </Formulario>
            <HandleButton>
              <HandleEditarButton hidden={formStatus == "Editar"}>
                <DarkButton
                  title={"EDITAR"}
                  execute={() => {
                    console.log(formStatus);
                    setFormStatus("Editar");
                  }}
                />
                 <HandleEditarButton hidden={formStatus == "Editar"}>
                  <DarkButton title={"EDITAR SENHA"} execute={() => { setEditarSenhaModal(true)}} />
                </HandleEditarButton>{" "}
              </HandleEditarButton>
             

              <HandleOperationButtons hidden={formStatus == "Visualizar"}>
                <DarkButton
                  title={"CANCELAR"}
                  execute={() => {
                    console.log(formStatus);
                    restoreValues();
                    setFormStatus("Visualizar");
                  }}
                />
              </HandleOperationButtons>
              <HandleOperationButtons hidden={formStatus == "Visualizar"}>
                <DarkButton
                  title={"SALVAR"}
                  execute={() => {
                    if (validaForm()) {
                      post();
                    }
                  }}
                />
              </HandleOperationButtons>
            </HandleButton>
            {funcionarioCartorio.ID?
            <EditarSenhaModal
            open={editarSenhaModal}
            onClose={() => setEditarSenhaModal(false)}
            funcionarioCartorio={funcionarioCartorio}
          />:
          <EditarSenhaModal
              open={editarSenhaModal}
              onClose={() => setEditarSenhaModal(false)}
             funcionarioPrefeitura={FuncionarioPrefeitura}
            />
            }
            
            <Alert
              open={error.message.length > 0}
              onClose={() => setError({ message: "", title: "" })}
              message={error.message}
              title={error.title}
            />

            <ModalLoader loading={loading} />
          </>
        }
      />
    </Container>
  );
}
